var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ad)?_c('div',{staticClass:"sponsor-ad"},[_c('span',{staticClass:"sponsor-ad__label"},[_vm._v("Sponsored by")]),_c('advertisement-placement',{attrs:{"placement":"sponsor"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }